<template>
  <el-popover
      placement="bottom"
      :width="400"
      :visible="visible"
  >
    <div class="flex flex-col gap-2">
      <el-select
          filterable
          clearable
          class="col-span-3"
          value-key="id"
          :placeholder="t('selectItems')"
          multiple
          v-model="selectedItems"
          remote
          :remote-method="searchItemsMultiSelect"
      >
        <el-option
            v-for="option in items"
            :key="option.id"
            :label="option.name"
            :value="option"
        ></el-option>
      </el-select>
      <div class="flex items-center justify-between">
        <div class="flex gap-2">
          <el-button @click="addExam(element)" type="primary" class="!m-0">
            {{ t('checkout') }}
          </el-button>
          <el-button @click="visible = false" type="danger" class="!m-0">
            {{ t('cancel') }}
          </el-button>
        </div>
        <div>
          {{ formatDinero(order.computeTotal()) }}
        </div>
      </div>
    </div>

    <template #reference>
      <button
          class="px-3 py-1 bg-green-500 text-black rounded-md hover:bg-green-600 transition-colors"
          @click="visible = !visible"
      >
        {{ t('addExam') }}
      </button>
    </template>
  </el-popover>

  <el-dialog v-model="cashierPinDialogOpen" width="30%">
    <div>
      <!-- Enter the pin -->
      <div class="my-2">
        <p>{{ t('enterCashierPin') }}</p>
      </div>

      <!-- password input up to 6 chars -->
      <div class="my-2">
        <el-input
            id="password"
            v-model="cashierPin"
            type="password"
            required
            show-password
            autofocus
            dir="ltr"
            :maxlength="4"
            :minlength="4"
            @keyup.enter="submitOrder"
            ref="cashierPinInput"
        />
      </div>

      <!-- finish payment -->
      <div class="flex items-center justify-between mb-2">
        <horizontal-button
            class="text-lg complete-payment"
            :title="t('buttons.completePay')"
            @click="submitOrder"
            :rounded="false"
        />
      </div>
    </div>
  </el-dialog>
  <el-drawer
      v-model="checkoutDrawerOpen"
      v-if="checkoutDrawerOpen"
      :direction="'rtl'"
      @open="openCheckoutDialog"
      :lock-scroll="false"
      class="overflow-scroll"
  >
    <div class="px-5" :style="!shortView ? 'margin-top: -20px !important' : ''">
      <div class="mb-2 w-full">
        <!-- I chose to keep the below as a comment just in case we decided to use labels later on again -->
        <!-- <p class="mb-2 font-semibold">{{ t("selectPaymentType") }}</p> -->
        <el-radio-group class="w-full flex !flex-nowrap"
                        v-model="order.paymentType">
          <el-radio-button class="flex-1 text-2xl" label="direct" border>
            {{ t('invoiceTypes.full') }}
          </el-radio-button>
          <el-radio-button class="flex-1 text-2xl" label="credit_sale" border>
            {{ t('invoiceTypes.credit') }}
          </el-radio-button>
          <el-radio-button class="flex-1 text-2xl" label="layaway" border>
            {{ t('invoiceTypes.layaway') }}
          </el-radio-button>
          <el-radio-button v-if="order.orderType != 'direct'"
                           class="flex-1 text-2xl" label="cash_on_delivery"
                           border>
            {{ t('invoiceTypes.cashOnDelivery') }}
          </el-radio-button>
        </el-radio-group>
      </div>

      <!--              <div>-->
      <!--                totalPaidAmount-->
      <!--                {{order.totalPaidAmount}}-->
      <!--              </div>-->
      <!--              <div>-->
      <!--                invoice totalPaidAmount-->
      <!--                {{order.invoice.totalPaidAmount}}-->
      <!--              </div>-->
      <multi-currency-payment-input
          v-model:total-paid="order.invoice.totalPaidAmount"
          v-model:change-due="order.changeDueAmount"
          v-model:total-paid-in-cash-before-change="order.invoice.reqOnlyTotalCashPaidAmount"
          v-model:total-paid-in-epayment="order.invoice.reqOnlyTotalEpaymentAmount"
          v-model:cash-multi-currency-breakdown="
                  order.invoice.reqOnlyCashMultiCurrencyBreakdown
                "
          :totalDue="order.computeTotalAfterDiscount().getAmount()"
          :order="order"
          @insurance="onInsurance"
      />
      <!--              <div-->
      <!--                  class="flex justify-between items-center text-base font-bold mx-5 mt-1"-->
      <!--                  dir="ltr">-->
      <!--                <div>{{ t('shippingExpense') }}</div>-->
      <!--                <div dir="ltr" class="bg-white w-1/2 p-1 border border-gray-300">{{formatMoney(order.invoice.shippingFeeAmount || 0, "IQD")}}</div>-->
      <!--              </div>-->


      <div class="mt-1">
        <div>{{ t('notes') }}</div>
        <div>
          <el-input v-model="order.paymentNotes" :rows="2" type="textarea"
                    placeholder=""/>
        </div>
      </div>

      <div class="flex items-center justify-between my-2">
        <horizontal-button
            class="text-lg complete-payment"
            :title="t('buttons.completePay')"
            @click="openCashierPinDialog()"
            :rounded="false"
        />
      </div>
    </div>
  </el-drawer>
</template>
<script lang="ts" setup>
import {useI18n} from "vue-i18n";
import {ElInput, ElMessage} from "element-plus";
import HorizontalButton from "@/components/HorizontalButton.vue";
import MultiCurrencyPaymentInput
  from "@/components/money/MultiCurrencyPaymentInput.vue";
import {nextTick, onMounted, ref} from "vue";
import {i18nOrderMessages, Order} from "@/models/sales/Order";
import User from "@/models/user/User";
import {Register} from "@/models/company/Register";
import Location from "@/models/company/Location";
import {useSettingsStore} from "@/stores/settingsStore";
import {localizeFieldName} from "@/plugins/i18n";
import {useHTTP} from "@/plugins/http";
import {useAlertModal} from "@/plugins/alert-modal/alert-modal";
import {useContext} from "@/plugins/context";
import Item from "@/models/inventory/Item";
import {formatDinero} from "../../utils/money";
import {watch} from "vue-demi";
import Customer from "@/models/customer/Customer";

const props = defineProps(['queue', 'shortView'])
const emit = defineEmits(['orderCreated'])

const messages = {
  en: {
    ...i18nOrderMessages.en,
    shipping: "Shipping",
    onUs: "On Us",
    carrier: 'Carrier',
    shippingExpense: 'Shipping',
    notes: 'Notes',
    totalItems: 'Total Items',
    totalDiscount: 'Total Discount',
    subTotal: 'Sub Total',
    totalDue: 'Total Due',
    searchItems: 'Enter item barcode or SKU or name',
    delete: 'Delete',
    noCustomer: 'No Customer Selected',
    minimumHasToBePaid: 'Minimum has to be Paid',
    noSalesRep: 'No Sales Rep Selected',
    amount: 'Amount',
    percentage: 'Percentage',
    enterCashierPin: 'Enter cashier pin',
    buttons: {
      addCustomer: 'Add Customer',
      payment: 'Payment',
      direct: 'Direct',
      creditSale: 'Credit Sale',
      layaway: 'Layaway',
      quote: 'Save as Quote',
      cancel: 'Cancel Order',
      cancelDiscount: 'Cancel Discount',
      confirm: 'Confirm',
      completePay: 'Process Payment',
      checkout: 'Checkout',
      printQuote: 'Print Quote',
      checkoutQuote: 'Checkout Quote Items',
      newTransaction: 'New Transaction',
      cashOnDelivery: 'Cash On Delivery'
    },

    selectSerials: 'Select serials',
    selectCustomer: 'Select a customer',
    selectPaymentType: 'Select order type',

    outOfStockErr:
        'Item {name} is out of stock. Please update your stock before selling this item',
    cantSellItemPackWithSerializedItem: 'Can\'t sell item pack with Serialized Item',

    quantityExceedsTheStockQuantity: 'There are only {quantity} unit available for sale for item {name} in the system. Please make sure to update the item stock before executing this order.',

    successMsg: 'Sale complete',

    errPaymentMustMatch:
        "Payment must be made in full. If you'd like to pay partially, choose credit sale",

    errCashierPinRequired: 'Cashier pin is required',
    itemCustomPrice: 'Item Custom Price',
    selectedPrice: 'Selected Price',
    itemNotFound: 'Item Not Found',
    addExam: 'Add Exam',
    checkout: 'Checkout',
    cancel: 'Cancel',
    selectItems: 'Select Items'
  },
  ar: {
    ...i18nOrderMessages.ar,
    shipping: "التوصيل",
    onUs: "علينا",
    carrier: 'شركة التوصيل',
    shippingExpense: 'اجور نقل',
    notes: 'الملاحظات',
    totalItems: 'إجمالي العناصر',
    totalDiscount: 'اجمالي التخفيض',
    subTotal: 'المبلغ الإجمالي',
    totalDue: 'الاجمالي المستحق',
    searchItems: 'ادخل الباركود او ال SKU او اسم المنتج',
    delete: 'حذف',
    noCustomer: 'لم يتم اختيار أي زبون',
    minimumHasToBePaid: 'يجب دفع الحد الأدنى',
    noSalesRep: 'لم يتم اختيار أي ممثل بيع',
    amount: 'الخصم بالمبلغ',
    percentage: 'الخصم بالنسبة',
    enterCashierPin: 'ادخل رمز الكاشير الخاص بك',
    buttons: {
      addCustomer: 'اضافة زبون',
      payment: 'دفع',
      direct: 'مباشر',
      creditSale: 'آجل',
      layaway: 'عربون',
      quote: 'الحفظ كعرض',
      cancel: 'الغاء البيع',
      cancelDiscount: 'الغاء التخفيض',
      confirm: 'التأكيد',
      completePay: 'اتمام الدفع',
      checkout: 'الدفع',
      printQuote: 'اطبع قائمة التسعير',
      checkoutQuote: 'إتمام بيع قائمة التسعير',
      newTransaction: 'عملية بيع جديدة',
      cashOnDelivery: 'دفع عن التوصيل'
    },

    selectSerials: 'اختر الارقام',
    selectCustomer: 'اختر زبون',
    selectPaymentType: 'اختر نوع البيع',

    outOfStockErr: 'نفذ مخزون المنتج {name}. يرجى اعادة تحديث المخزن قبل بيع المنتج.',
    cantSellItemPackWithSerializedItem: 'لا يمكن بيع حزمة منتج تحتوي على منتج مرقم',
    quantityExceedsTheStockQuantity: "يحتوي المخزن على {quantity} قطعة من المنتج {name}. لأتمام البيع، يرجى تحديث كمية المنتج في المخزن.",

    successMsg: 'تم اكمال البيع',

    errPaymentMustMatch:
        'يجب ان يتم دفع المبلغ بشكل كامل. لدفع مبلغ جزئي، قم بتحويل نوع الدفع الى دين او عربون',

    errCashierPinRequired: 'يرجى ادخال رمز الكاشير لاتمام البيع',
    itemCustomPrice: 'اختيار سعر المنتج',
    selectedPrice: 'السعر المختار',
    itemNotFound: 'لم يتم ايجاد المنتج',
    addExam: 'اضافة فحص',
    checkout: 'الدفع',
    cancel: 'الغاء',
    selectItems: 'اختر العناصر'
  }
}
const {t} = useI18n({messages, useScope: 'global'})
const http = useHTTP()
const alertModal = useAlertModal()
const ctx = useContext()
const order = ref<Order>(new Order())
const settingsStore = useSettingsStore()
const checkoutDrawerOpen = ref(false)
const cashierPinDialogOpen = ref(false)
const cashierPin = ref('')
const visible = ref(false)
const error = ref({title: '', body: ''})
const cashierPinInput = ref<any>()
const items = ref<Item[]>([]);
const selectedItems = ref<Item[]>([]);

watch(() => selectedItems, (newValue) => {
  order.value = new Order();
  newValue.value.forEach(i => {
    order.value.addItem(i)
  })
  order.value.customerID = props.queue.customerID;
  order.value.invoice.customerID = props.queue.customerID;
}, {deep: true})

function addExam() {
  if (order.value.orderItems.length) {
    checkoutDrawerOpen.value = true
    visible.value = false
  }
}

function openCheckoutDialog() {
  // nextTick(() => {
  //   /* @ts-ignore */
  //   const paymentInput = this.$refs['paymentInput']
  //   if (paymentInput) {
  //     /* @ts-ignore */
  //     paymentInput.cashReceivedInputFocus()
  //   }
  // })
  // order.value.prepareForCheckout();
  // if (!this.isOrderValid()) {
  //   this.checkoutDrawerOpen = false
  // }
}

function isOrderValid() {
  const errors: string[] = []
  if (order.value.customerID === '' && order.value.paymentType !== 'direct') {
    errors.push(t('noCustomer'))
  }

  if (order.value.customerID === '' && order.value.invoice.insuranceID) {
    errors.push(t('noCustomer'))
  }

  if (order.value.invoice.reqOnlyTotalCashPaidAmount == 0 && order.value.invoice.reqOnlyTotalEpaymentAmount == 0 && order.value.paymentType === 'layaway') {
    errors.push(t('minimumHasToBePaid'))
  }

  order.value.orderItems.forEach((oi) => {
    if (oi.item?.isSerialized && oi.serialIDs.length !== oi.quantity) {
      const errMsg = `${oi.item.name}: ${t('validation.matchingLength', {
        thisField: localizeFieldName('lenSerialNumbers', i18nOrderMessages),
        thatField: localizeFieldName('quantity', i18nOrderMessages)
      })}`
      if (!oi.specialOrderItemInfo)
        errors.push(errMsg)
    }

    if (oi.specialOrderItemInfo && oi.specialOrderItemInfo.vendor) {
      if (order.value.customerID === '') {
        errors.push(t('noCustomer'))
      }
      return false;
    }
  })

  if (errors.length) {
    error.value.title = t('validation.inputErrors')
    error.value.body = errors.join('\n')
    ElMessage.error({message: errors.join('\n')})
    checkoutDrawerOpen.value = false

    return false
  }

  return true
}

function isValidPayment() {
  const totalPaid =
      order.value.invoice.reqOnlyTotalCashPaidAmount +
      order.value.invoice.reqOnlyTotalEpaymentAmount

  if (order.value.paymentType === 'direct' && order.value.totalDueAmount > totalPaid) {
    error.value.title = t('errPaymentMustMatch')
    ElMessage.error({message: t('errPaymentMustMatch')})
    checkoutDrawerOpen.value = false
    cashierPinDialogOpen.value = false

    return false
  }

  return true
}

async function openCashierPinDialog() {
  // for validation purposes
  order.value.preparePayload(
      ctx.currentUser as User,
      ctx.currentRegister as Register,
      ctx.currentLocation as Location
  )

  if (!isOrderValid() || !isValidPayment()) {
    return
  }

  if (useSettingsStore().getValue('is_cashier_pin_required') == 'true') {
    cashierPinDialogOpen.value = true

    nextTick(() => {
      setTimeout(() => {
        cashierPinInput.value.focus()
      }, 0)
    })
    return;
  }
  submitOrder()
}

async function submitOrder() {
  if (useSettingsStore().getValue('is_cashier_pin_required') == 'true') {
    if (cashierPin.value === '') {
      error.value.title = t('errCashierPinRequired')
      ElMessage.error({message: t('errCashierPinRequired')})
      cashierPinDialogOpen.value = false
      checkoutDrawerOpen.value = false
      return
    }
  }

  const requestData = order.value.preparePayload(
      ctx.currentUser as User,
      ctx.currentRegister as Register,
      ctx.currentLocation as Location
  )

  if (!isOrderValid() || !isValidPayment()) {
    return
  } else {
    error.value.title = ''
    error.value.body = ''
    cashierPinDialogOpen.value = false

    try {
      const o: Order = await http.post<Order>(Order.ENDPOINT+`?queue_id=${props?.queue?.id}`, requestData, {
        headers: {pin: cashierPin.value}
      })

      alertModal.showSuccess({title: t('successMsg')})
      emit('orderCreated', o);
    } catch (err) {
      console.log(err)
      error.value.title = err.title
      error.value.body = err.body
      ElMessage.error({message: err.body})
      checkoutDrawerOpen.value = false
    }
  }
}

async function searchItemsMultiSelect(query: string) {
  if (!query) {
    query = ''
  }
  try {
    const url = `${Item.ENDPOINT}?tag=examination&q=${query}`
    const itemsRes = await http.get<Item[]>(url)
    items.value = itemsRes.map((item) => Item.from(item))
  } catch (error) {
    items.value = []
  }
}
</script>
